import createCache from "@emotion/cache";
import AddCircleOutlineIcon from "@mui/icons-material/AddCircleOutline";
import ArrowDropDownIcon from "@mui/icons-material/ArrowDropDown";
import DeleteOutlineOutlinedIcon from "@mui/icons-material/DeleteOutlineOutlined";
import MoreHorizIcon from "@mui/icons-material/MoreHoriz";
import SearchIcon from "@mui/icons-material/Search";
import {
  Box,
  createTheme,
  Grid,
  IconButton,
  InputBase,
  Paper,
  Table,
  TableBody,
  TableCell,
  tableCellClasses,
  TableContainer,
  TableHead,
  TableRow,
  Typography,
} from "@mui/material";
import MuiAccordion, { AccordionProps } from "@mui/material/Accordion";
import MuiAccordionDetails from "@mui/material/AccordionDetails";
import MuiAccordionSummary, {
  AccordionSummaryProps,
} from "@mui/material/AccordionSummary";
import { styled } from "@mui/material/styles";
import Fuse from "fuse.js";
import React, { useEffect, useState } from "react";
import { useMutation } from "react-query";
import { useHistory } from "react-router-dom";
import { toast } from "react-toastify";
import { prefixer } from "stylis";
import rtlPlugin from "stylis-plugin-rtl";
import DeleteModal from "../../components/modals/DeleteModal";
import ModalCheckbox from "../../components/modals/ModalCheckbox";
import { GetIbanResponse } from "../../models/iban.model";
import {
  AllStoresAndBranchesResponse,
  BranchAndStoreAccessResponse,
  Branches,
} from "../../models/supplierUserBarnch.model";
import {
  GetBranchAndStoresByIbanId,
  GetIbanById,
} from "../../services/iban.service";
import AssignBranchToIbanHeader from "../permission/components/AssignBranchToIbanHeader";
import BranchesAccardionTableRows from "../permission/components/BranchesAccardionTableRows";
import SupplierBranchUserDetailSkeleton from "../permission/components/SupplierBranchUserDetailSkeleton";
import { UpdateBranchesIban } from "../../services/branch.service";
import { GetAllStoresAndBranches } from "../../services/dropdown.service";
import { IList } from "../../models/common.model";

const Accordion = styled((props: AccordionProps) => (
  <MuiAccordion disableGutters elevation={0} square {...props} />
))(({ theme }) => ({
  border: `1px solid ${theme.palette.divider}`,
  "&:not(:last-child)": {
    borderBottom: 0,
  },
  "&::before": {
    display: "none",
  },
}));

const AccordionSummary = styled((props: AccordionSummaryProps) => (
  <MuiAccordionSummary
    expandIcon={
      <ArrowDropDownIcon sx={{ fontSize: "2rem", color: "#1D4A87" }} />
    }
    {...props}
  />
))(({ theme }) => ({
  backgroundColor:
    theme.palette.mode === "dark"
      ? "rgba(255, 255, 255, .05)"
      : "rgba(0, 0, 0, .03)",
  flexDirection: "row-reverse",
  "& .MuiAccordionSummary-expandIconWrapper.Mui-expanded": {
    transform: "rotate(180deg)",
  },
  "& .MuiAccordionSummary-content": {
    marginLeft: theme.spacing(1),
  },
}));

const AccordionDetails = styled(MuiAccordionDetails)(({ theme }) => ({
  padding: theme.spacing(2),
  borderTop: "1px solid rgba(0, 0, 0, .125)",
}));

const StyledTableCell = styled(TableCell)(({ theme }) => ({
  [`&.${tableCellClasses.head}`]: {
    backgroundColor: "#DAE0E4",
    color: "#1D4A87",
    fontSize: "14px",
    marginBottom: "50px",
  },
}));
const columns = [
  {
    id: 1,
    title: "عنوان شعبه",
  },
  {
    id: 2,
    title: "نوع شعبه",
  },
  {
    id: 3,
    title: "وضعیت شعبه",
  },
  {
    id: 4,
    title: "استان / شهر محل فعالیت",
  },

  {
    id: 5,
    title: "شماره تماس",
  },
  {
    id: 6,
    title: "شماره شبا",
  },
  {
    id: 7,
    title: "آدرس",
  },
];
const theme = createTheme({
  direction: "rtl", // Both here and <body dir="rtl">
});
// Create rtl cache
const cacheRtl = createCache({
  key: "muirtl",
  stylisPlugins: [prefixer, rtlPlugin],
});
const deactiveUserStyle = {
  position: "absolute" as "absolute",
  top: "50%",
  left: "50%",
  transform: "translate(-50%, -50%)",

  minWidth: {
    xs: 250,
    sm: 300,
    md: 400,
    lg: 500,
  },
  maxWidth: {
    xs: 250,
    sm: 300,
    md: 400,
    lg: 500,
  },

  maxHeight: "70vh",
  minHeight: "30vh",
  bgcolor: "background.paper",
  boxShadow: 24,
  p: 4,
  // overflow: "auto",
  // overflowX: "hidden",
  paddingRight: "3vh",
  paddingTop: "4vh",
  // direction: "ltr",
  borderRadius: "5px",
  "&::-webkit-scrollbar": {
    width: 7,
  },
  "&::-webkit-scrollbar-track": {
    backgroundColor: "#F9FAFC",
    border: "2px solid #DAE0E4",
  },
  "&::-webkit-scrollbar-thumb": {
    backgroundColor: "#9AAFC4",
  },
};
const stickyColOlite = "stickyColOlite";
const stickyColOdark = "stickyColOdark";
const AssignBranchToIban = () => {
  const history = useHistory<{
    id: number;
  }>();
  const ibanId =
    history?.location?.state?.id !== undefined
      ? history?.location?.state?.id
      : Number(window.localStorage.getItem("BRANCH_IBANID"));
  const [ibanResponse, setibanResponse] = useState<GetIbanResponse>();
  const [branchAndStoreAccess, setBranchAndStoreAccess] = useState<
    BranchAndStoreAccessResponse[]
  >([]);
  const [searchTerm, setSearchTerm] = useState("");
  const [openModal, setOpenModal] = useState(false);
  const [allStoresAndBranches, setAllStoresAndBranches] = useState<
    AllStoresAndBranchesResponse[]
  >();
  const [openDeleteModal, setOpenDeleteModal] = useState(false);
  const [selectedBranchRow, setSelectedBranchRow] = useState<Branches>();
  const [changeValue, setChangeValue] = useState<any[]>();
  const [branchAndStore, setBranchAndStore] = useState<any>();

  const handleSearchInput = (e: React.ChangeEvent<HTMLInputElement>) => {
    setSearchTerm(e.target.value.trim().toLocaleLowerCase());
  };
  const handleBranchDelete = (branches: Branches) => {
    setSelectedBranchRow(branches);
    setBranchAndStore({ branches: [branches], storeId: null });
    setOpenDeleteModal(true);
  };
  const onClaoseDeleteModal = () => {
    setSelectedBranchRow(undefined);
    setBranchAndStore(undefined);
  };
  const handleDeleteRcordStore = () => {
    const selectedStoreIds = branchAndStore?.branches?.map((item: any) => ({
      parentId: branchAndStore.storeId,
      childId: item.branchId,
    }));
    UpdateBranchesIbanMutate({
      branchStoreIds: selectedStoreIds,
    });
  };
  const fuse = new Fuse(branchAndStoreAccess, {
    keys: [
      "storeTitle",
      "isActiveTitle",
      "branches.branchTitle",
      "branches.branchTypeTitle",
      "branches.isActiveTitle",
      "branches.ibanAndOwner",
      "branches.phoneNumber",
      "branches.address",
    ],
    includeScore: true,
    threshold: 0.2,
    ignoreLocation: true,
    useExtendedSearch: true,
  });

  // جستجوی داده‌ها
  const results = fuse.search(searchTerm);

  const filteredResults = searchTerm
    ? results
        .map(({ item }) => {
          // بررسی اینکه فروشگاه مطابق جستجو باشد
          const storeMatch = Object.values(item).some((value) =>
            value?.toString().includes(searchTerm)
          );

          // فیلتر کردن شعب مطابق جستجو
          const matchedBranches = item.branches.filter((branch) =>
            Object.values(branch).some((value) =>
              value?.toString().includes(searchTerm)
            )
          );

          if (storeMatch) {
            return item; // اگر فروشگاه مطابق جستجو بود، تمام شعبش نمایش داده شود
          }

          if (matchedBranches.length > 0) {
            return {
              ...item, // حفظ اطلاعات فروشگاه
              branches: matchedBranches, // فقط شعبه‌های مطابق جستجو
            };
          }

          return null;
        })
        .filter(Boolean) // حذف موارد null
    : branchAndStoreAccess;

  const { mutate: GetIbanByIdMutate, isLoading } = useMutation(GetIbanById, {
    onSuccess: (data: GetIbanResponse) => {
      if (data) {
        setibanResponse(data);
      }
    },
    onError: () => {},
  });
  const { mutate: GetAllStoresAndBranchesMutate } = useMutation(
    GetAllStoresAndBranches,
    {
      onSuccess: (data: AllStoresAndBranchesResponse[]) => {
        if (data) {
          setAllStoresAndBranches(data);
        }
      },
      onError: () => {},
    }
  );
  const {
    mutate: GetBranchAndStoresByIbanIdMutate,
    isLoading: getDataLoading,
  } = useMutation(GetBranchAndStoresByIbanId, {
    onSuccess: (data: BranchAndStoreAccessResponse[]) => {
      if (data) {
        setBranchAndStoreAccess(data);
      }
    },
    onError: () => {},
  });
  const { mutate: UpdateBranchesIbanMutate } = useMutation(UpdateBranchesIban, {
    onSuccess: (data: boolean) => {
      if (data) {
        GetBranchAndStoresByIbanIdMutate({
          ibanId: ibanId,
        });
        setOpenModal(false);
        setOpenDeleteModal(false);
        setSelectedBranchRow(undefined);
        setBranchAndStore(undefined);
        toast.success("تغییرات با موفقیت انجام شد");
      }
    },
    onError: () => {},
  });
  useEffect(() => {
    GetIbanByIdMutate({
      id: ibanId,
    });
    GetBranchAndStoresByIbanIdMutate({
      ibanId: ibanId,
    });
    GetAllStoresAndBranchesMutate({});
  }, []);
  useEffect(() => {
    if (changeValue) {
      const selectedStoreIds = changeValue.map((item: any) => ({
        parentId: item.parentId,
        childId: item.childId,
      }));
      UpdateBranchesIbanMutate({
        branchStoreIds: selectedStoreIds,
        ibanId,
      });
    }
  }, [changeValue]);
  if (isLoading || getDataLoading) {
    return <SupplierBranchUserDetailSkeleton />;
  }
  return (
    <>
      <Box
        width={"100%"}
        height={{
          xs: "fit-content",
          sm: "fit-content",
          md: "95vh",
          lg: "85vh",
        }}
        border={"2px solid #DAE0E4"}
        borderRadius={"5px"}
        padding={"2rem"}
        position={"relative"}
      >
        <Grid container>
          <Grid
            item
            xs={12}
            sx={{
              background: "#F9FAFC",
              width: "100%",
              border: "1px solid #EDEFEF",
              borderRadius: "5px",
            }}
          >
            <AssignBranchToIbanHeader getibanResponse={ibanResponse!} />
          </Grid>
          <Grid container gap={"20px"}>
            <Grid item xs={12}>
              <Box
                sx={{
                  display: "flex",
                  alignItems: "center",
                  justifyContent: "space-between",
                  marginTop: "20px",
                }}
              >
                <Typography
                  color={"#1565C0"}
                  fontWeight={"bold"}
                  padding={"0.5rem"}
                  borderRadius={"5px"}
                  sx={{
                    cursor: "pointer",
                    width: "fit-content",
                    "&: hover": { color: "#fff", background: "#1565C0" },
                  }}
                  onClick={() => {
                    setOpenModal(true);
                  }}
                >
                  <AddCircleOutlineIcon sx={{ marginLeft: "7px" }} />
                  افزودن شعبه
                </Typography>

                <Paper
                  elevation={0}
                  style={{
                    border: "1px solid #DAE0E4",
                    display: "flex",
                    borderRadius: "5px",
                    height: "35px",
                    width: "20vw",
                  }}
                  square={true}
                >
                  <InputBase
                    sx={{
                      ml: 1,
                      flex: 1,
                      paddingX: "16px",
                      height: "30px !important",
                    }}
                    placeholder='جستجو'
                    onChange={handleSearchInput}
                  />

                  <IconButton
                    type='button'
                    sx={{ color: "#9AAFC4" }}
                    aria-label='search'
                  >
                    <SearchIcon />
                  </IconButton>
                </Paper>
              </Box>
            </Grid>
            <Grid item xs={12} sx={{ height: "60vh", overflowY: "auto" }}>
              {filteredResults.length > 0 ? (
                filteredResults.map((branchAndStoreAccess2, index) => (
                  <Accordion
                    defaultExpanded={index === 0}
                    sx={{ padding: "10px" }}
                  >
                    <AccordionSummary
                      aria-controls={`panel${index + 1}d-content`}
                      id={`panel${index + 1}d-header`}
                      sx={{
                        background: index % 2 === 0 ? "#fff" : "",
                        width: "100%",
                      }}
                    >
                      <Grid
                        container
                        sx={{ justifyContent: "space-between !important" }}
                      >
                        <Grid item>
                          <Typography
                            sx={{
                              marginRight: "1.5rem",
                              fontWeight: "bold",
                              color: "#1D4A87",
                            }}
                          >
                            {branchAndStoreAccess2?.storeTitle}{" "}
                            <span style={{ color: "#FB8C00" }}>
                              ({branchAndStoreAccess2?.count} شعبه از{" "}
                              {branchAndStoreAccess2?.totalCount}){" "}
                            </span>
                            {branchAndStoreAccess2?.isActiveTitle === "فعال" ? (
                              <span style={{ color: "#28A745" }}>- فعال</span>
                            ) : (
                              <span style={{ color: "#E6123D" }}>
                                - غیرفعال
                              </span>
                            )}
                          </Typography>
                        </Grid>
                        <Grid item>
                          <Grid container gap={"7px"}>
                            <Grid
                              color={"#1D4A87"}
                              item
                              onClick={(e) => {
                                e.stopPropagation();
                                setBranchAndStore(branchAndStoreAccess2!);
                                setOpenDeleteModal(true);
                              }}
                            >
                              <DeleteOutlineOutlinedIcon />
                            </Grid>
                          </Grid>
                        </Grid>
                      </Grid>
                    </AccordionSummary>
                    {branchAndStoreAccess2!.branches.length > 0 && (
                      <AccordionDetails>
                        <Typography className='userReport-list'>
                          <TableContainer
                            component={Paper}
                            sx={{ maxHeight: 440 }}
                          >
                            <Table
                              stickyHeader
                              sx={{
                                minWidth: { xs: 0, sm: 0, md: 700, lg: 900 },
                              }}
                              aria-label='customized table'
                            >
                              <TableHead>
                                <TableRow className='nowrapClass'>
                                  {columns.length > 0 &&
                                    columns.map((column) => (
                                      <StyledTableCell align='center'>
                                        {column.title}
                                      </StyledTableCell>
                                    ))}
                                  <StyledTableCell
                                    align='center'
                                    className='stickyColOLeft'
                                  >
                                    <MoreHorizIcon />
                                  </StyledTableCell>
                                </TableRow>
                              </TableHead>

                              <TableBody
                                sx={{
                                  outline: "1px solid #DAE0E4",
                                }}
                              >
                                {branchAndStoreAccess2?.branches.map(
                                  (item: Branches, rowIndex) => (
                                    <BranchesAccardionTableRows
                                      branchs={item}
                                      key={item.branchId}
                                      handleBranchDelete={handleBranchDelete}
                                      handelBackgrundIcon={`${
                                        rowIndex % 2 == 0
                                          ? stickyColOlite
                                          : stickyColOdark
                                      }`}
                                    />
                                  )
                                )}
                              </TableBody>
                            </Table>
                          </TableContainer>
                        </Typography>
                      </AccordionDetails>
                    )}
                  </Accordion>
                ))
              ) : (
                <Box
                  sx={{
                    width: "100%",
                    height: "100%",
                    background: "#F9FCFE",
                    display: "flex",
                    justifyContent: "center",
                    alignItems: "center",
                    marginTop: "10px",
                    flexDirection: "column",
                  }}
                >
                  <img src='/images/emptyStore.png' />
                  <Typography color={"#9AAFC4"} fontSize={"1.2rem"}>
                    شعبه یافت نشد
                  </Typography>
                </Box>
              )}
            </Grid>
          </Grid>
        </Grid>
        <DeleteModal
          openDeleteModal={openDeleteModal}
          setOpenDeleteModal={setOpenDeleteModal}
          text={
            <>
              آیا از حذف این{" "}
              {!branchAndStore?.storeTitle ? (
                <>
                  شعبه{" "}
                  <span style={{ color: "#E6123D" }}>
                    " {selectedBranchRow?.branchTitle} "
                  </span>
                </>
              ) : (
                <>
                  فروشگاه{" "}
                  <span style={{ color: "#E6123D" }}>
                    " {branchAndStore?.storeTitle} "
                  </span>
                </>
              )}{" "}
              اطمینان دارید؟
            </>
          }
          handleDel={handleDeleteRcordStore}
          onCloseModal={onClaoseDeleteModal}
        />
        {openModal === true && allStoresAndBranches!.length > 0 ? (
          <ModalCheckbox
            openModal={openModal}
            setOpenModal={setOpenModal}
            allStoresAndBranches={allStoresAndBranches!}
            setChangeValue={setChangeValue}
            title={"افزودن دسترسی شعبه"}
            label={"انتخاب فروشگاه/شعبه"}
            titleChip={"شعب اضافه شده"}
          />
        ) : (
          ""
        )}
      </Box>
    </>
  );
};

export default AssignBranchToIban;
